import {
  Box,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Tooltip,
  Avatar,
} from "@chakra-ui/react";
import { useEffect } from "react";
// import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as ContextMenuIcon } from "../../svg/ContextMenu.svg";
import books from "../../assets/Books.png";
import documents from "../../assets/Documents.png";
import video from "../../assets/Video.png";
// import EmployeesDisplay from "../common/EmployeesDisplay";
import { Link } from '@chakra-ui/react'

export default function IndividualCourseCard({
  image,
  name,
  dates,
  certifiedEmployee,
  enrolledEmployee,
  topics,
  contentUrl,
  id,
  removeCourse,
  classes,
  subject,
  category,
}) {
  const itemTypes = {
    Books: books,
    Documents: documents,
    Video: video,
  };

  // const [extraCertifiedEmployeesCount, setExtraCertifiedEmployeesCount] = useState(0)
  // const [extraEnrolledEmployeesCount, setExtraEnrolledEmployeesCount] = useState(0)
  // const [visibleCE, setVisibleCE] = useState([])
  // const [visibleEE, setVisibleEE] = useState([])
  const history = useHistory();

  const setVisibleEmployees = () => {
    // setVisibleCE(employeesToDisplay(certifiedEmployee, 0))
    // setVisibleEE(employeesToDisplay(enrolledEmployee, 1))
  };

  useEffect(() => {
    setVisibleEmployees();
    // eslint-disable-next-line
  }, []);

  // const employeesToDisplay = (employees, flag) => {
  //     if (employees.length > 5) {
  //         flag === 0 ? setExtraEnrolledEmployeesCount(enrolledEmployee.length - 4) : setExtraCertifiedEmployeesCount(certifiedEmployee.length - 4)
  //         return employees.slice(0, 5)
  //     }
  //     else {
  //         return employees
  //     }
  // }

  const editHandler = () => {
    // dispatch(setEdit(id));
    history.push("/courses/edit-item/" + id);
  };

  return (
    <Box
      d="flex"
      width="100%"
      bg="white"
      borderRadius="2xl"
      my="1rem"
      p="1rem"
      justifyContent={["center", "center", "center", "flex-start"]}
      alignItems={["flex-start", "flex-start", "flex-start", "center"]}
      flexDirection={["column", "column", "column", "row"]}
      _hover={{ boxShadow: "xl" }}
      position="relative"
    >
      <Box
        d="flex"
        width={["100%", "100%", "100%", "30%"]}
        flexDir={["column", "column", "column", "row"]}
        mb={["3rem", "3rem", "3rem", "0"]}
      >
        <Image
          src={image}
          width="60px"
          height="60px"
          fallbackSrc="https://source.unsplash.com/random/800x600"
          objectFit="cover"
          d={["none", "none", "none", "flex"]}
          borderRadius="50%"
          mr="1rem"
        />
        <Box
          d="flex"
          flexDir="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Tooltip
            label={name}
            fontSize="15px"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="400"
            color="#ffffff"
            bg="#1B1A1AB2"
            hasArrow
            placement="top"
          >
            <Text
              style={{ fontFamily: "Mulish, sans-serif" }}
              fontWeight="700"
              fontSize={["14px", "14px", "16px", "16px"]}
              color="#333333"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              cursor="pointer"
              w="20ch"
            >
              {name ? name : "Course Name"}
            </Text>
          </Tooltip>
          <Text
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="400"
            fontSize={["14px", "14px", "16px", "16px"]}
            color="#00000080"
          >
            {dates}
          </Text>
        </Box>
      </Box>

      <Box
        d="flex"
        width={["100%", "100%", "100%", "20%"]}
        flexDir={["column", "column", "column", "row"]}
        mb={["3rem", "3rem", "3rem", "0"]}
      >
        <Text
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="700"
          fontSize={["14px", "14px", "16px", "16px"]}
          color="#333333"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          cursor="pointer"
          textAlign="center"
          w="20ch"
        >
          {classes && classes.name}
        </Text>
      </Box>

      <Box
        d="flex"
        width={["100%", "100%", "100%", "20%"]}
        flexDir={["column", "column", "column", "row"]}
        mb={["3rem", "3rem", "3rem", "0"]}
      >
        <Text
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="700"
          fontSize={["14px", "14px", "16px", "16px"]}
          color="#333333"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          cursor="pointer"
          textAlign="center"
          w="20ch"
        >
          {subject && subject.name}
        </Text>
      </Box>

      <Box d="flex" width="10%" justifyContent="center" alignItems="center">
        <Link href={contentUrl} isExternal>{category && category.name ? (
          <Avatar src={itemTypes[category.name]} />
        ) : (
          <></>
        )}
        </Link>
      </Box>

      {/* <Box d='flex' width='20%' justifyContent='center' alignItems='center'>
                {certifiedEmployee}
             </Box>
             <Box d='flex' width='20%' justifyContent='center' alignItems='center'>
                {enrolledEmployee}
             </Box> */}
      {/*<EmployeesDisplay employees={visibleEE} extraEmployeesCount={extraEnrolledEmployeesCount} width='20' maxVisible={'5'} />

            <EmployeesDisplay employees={visibleCE} extraEmployeesCount={extraCertifiedEmployeesCount} width='20' maxVisible={'5'} /> */}

      {/* <Box d='flex' width='10%' justifyContent='center' alignItems='center'>
                <Circle bg='#429fff' size={['22px', '25px', '25px', '40px']} border='1px solid white' color='white' style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['7px', '10px', '11px', '15px']}>
                    {topics}
                </Circle>
            </Box> */}

      <Box d="flex" width="15%" justifyContent="center" alignItems="center">
        {/* <Button
                    bgColor='#429fff'
                    color='white'
                    variant='outline'
                    p={['0.5rem', '0.5rem', '0.5rem', '0.75rem']}
                    size={['xs', 'sm', 'sm', 'md']}
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='lg'
                    fontSize={['7px', '10px', '11px', '15px']}
                    _hover={{ bg: "#3b8fe4" }}
                    onClick={() => history.push('/add-topics')}
                >+ Add Topic
                </Button> */}
      </Box>
      <Menu>
        <MenuButton
          as={IconButton}
          border="2px solid rgba(0, 0, 0, 0.1)"
          borderRadius="10px"
          icon={<ContextMenuIcon />}
          bg="white"
          _hover={{ bg: "#f8f8f8" }}
          _active={{ bg: "#f8f8f8" }}
          position="static"
          size={["xs", "sm", "sm", "lg"]}
          p="0.5rem 1rem"
        />
        <MenuList
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="700"
          fontSize="14px"
          color="#00000099"
          minW="0"
          w="150px"
          position="relative"
          zIndex="10"
        >
          <MenuItem onClick={editHandler}>Edit</MenuItem>
          <MenuItem onClick={() => removeCourse(id)}>Delete</MenuItem>
          {/* <MenuItem onClick={() => history.push('/quizzes/add-quizzes')}>Add Quiz</MenuItem> */}
          {/* <MenuItem onClick={() => history.push('/courses/' + id)}>View Details</MenuItem> */}
          {/* <MenuItem onClick={() => history.push('/course-dashboard/' + id)}>Course Dashboard</MenuItem> */}
        </MenuList>
      </Menu>
    </Box>
  );
}
